import React from "react";

const Banner = () => {
  return (
    <section className="bg-primary text-center rounded py-20">
      <h1 className="uppercase text-white font-bold text-3xl">
        bd-trust-bicycle
      </h1>
    </section>
  );
};

export default Banner;
